import React from 'react';
import ReactDOM from 'react-dom';
import Amplify from "aws-amplify";
import config from "./config";
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './index.css';

console.log(process.env.REACT_APP_STAGE);

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: "api",
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
    ]
  }
});

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js